<div class="modal-signup modal-content">
  <div>
    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


        <div class="card-header wh-header padding-bottom-0px padding-right-5px padding-left-10px">
          <div class="row">
            <div class="col-md-4 padding-right-0px">
              Embryo Grading
            </div>
            <div class="col-md-7 padding-right-0px">
              <button type="submit" class="btn font-size-13px actions-btn-prime float-right">Save</button>
            </div>
            <div class="col-md-1">
              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>




        </div>

        <div class="modal-body padding-top-0px">
          <div class="row border-top">
            <div class="col-md-4">
              <label class="margin-bottom-0px font-size-14">{{PatientName}}</label>
            </div>
            <div class="col-md-5">
              <label class="margin-bottom-0px font-size-14">Cycle No: {{Cyclenumber}}</label>
            </div>
          </div>
          <div class="row border-top   bk-color-light">
            <div class="col-md-6  text-align-left">
              <div><label class=" font-weight-bold margin-bottom-0px label-color-consultant">Well #</label> : <label class="margin-bottom-0px">{{Wellno}}</label></div>
              <!--<label>2</label>-->
            </div>
            <div class="col-md-6  text-align-left">
              <div><label class="label-color-consultant margin-bottom-0px font-weight-bold">Day</label> : <label class="margin-bottom-0px">{{Day}}</label></div>

            </div>

          </div>

          <div class="row border-bottom  bk-color-light">
            <div class="col-md-6  text-align-left">
              <div><label class=" font-weight-bold margin-bottom-0px label-color-consultant">Oocyte Quality</label> : <label>{{oqa}}</label></div>

            </div>
            <div class="col-md-6  text-align-left">
              <div><label class="label-color-consultant margin-bottom-0px  font-weight-bold">Ins.Tech</label> : <label>{{Technique}}</label></div>

            </div>

          </div>

          <div class="row">
            <div class="col-md-6 margin-top-5px">
              <div class="row">
                <div class="col-md-2 text-align-right padding-right-0px">
                  <label class="margin-bottom-0px font-size-12px">Picture:</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <img class="nav-link-hand " height="110px" [src]="DocumentUrl" width="200px">
                  <button type="button" class="btn  btn-sm margin-buttons button-new-embryo" tooltip="Add" (click)="openDocContent()"><i class="fas fa-plus nav-link-hand"></i></button>

                </div>
              </div>
            </div>
             <div class="col-md-6 margin-top-5px">
               <div class="row my-profile-form ">
                 <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                   <div class="row">
                     <div class="col-md-4  padding-right-0px text-align-left margin-tg-auto ">
                       <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Grade </label>
                     </div>
                     </div>
                   <div class="row">

                     <div class="col-md-6">
                       <CodeTypeValue CodeType="D{{Day}}GRA"
                                      id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                                      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                                      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">
                       </CodeTypeValue>


                     </div>

                   </div>


                 </div>
               </div>
               <div class="row my-profile-form ">
                 <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                   <div class="row">
                     <div class="col-md-4 padding-left-0px padding-right-0px text-align-right margin-tg-auto ">
                       <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cell Count</label>
                     </div>
                     </div>
<div class="row">

                     <div class="col-md-6">

                       <input type="number" class="form-control" placeholder="Cell Count"
                              id="CurrentSaveSingleEmbryoGradeInfoRequest.CellCount"
                              [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.CellCount"
                              name="CurrentSaveSingleEmbryoGradeInfoRequest.CellCount" #Doctor="ngModel"
                              maxlength="100" required>


                     </div>

                   </div>


                 </div>
               </div>
             </div>
          </div>

          

        
          <div class="row margin-top-5px margin-left-0px margin-right-0px bk-color-light2">
            <div class="col-md-4 display-inherit">
              <input type="checkbox" class="width-17p" name="CurrentSaveSingleEmbryoGradeInfoRequest.IsDiscarded"
                                                     [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.IsDiscarded" ><label class="font-size-14 margin-bottom-0px margin-left-5px margin-top-5px">Discard</label>
            </div>
            <div class="col-md-4 display-inherit">
              <input type="checkbox" class="width-17p" name="CurrentSaveSingleEmbryoGradeInfoRequest.IsFreeze"
                                                     [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.IsFreeze" ><label class="font-size-14 margin-bottom-0px margin-left-5px margin-top-5px">Freeze</label>
            </div>
            <div class="col-md-4 display-inherit" >
              <input type="checkbox" class="width-17p" name="CurrentSaveSingleEmbryoGradeInfoRequest.IsTransfer"
                                                     [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.IsTransfer" ><label class="font-size-14 margin-bottom-0px margin-left-5px margin-top-5px">Transfer</label>
            </div>
          </div>

          <div class="row" *ngIf="CurrentSaveSingleEmbryoGradeInfoRequest.IsDiscarded">
            <div class="col-md-12">
              <div class="card background-lightpink">
                <div class="card-body padding-all-0px">
                  <div class="row my-profile-form margin-top-10">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                        </div>

                        <div class="col-md-4 padding-right-0px">
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                    name="CurrentSaveSingleEmbryoGradeInfoRequest.DiscardedComments"
                                    [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.DiscardedComments" required minlength="1" maxlength="100"
                                    #addconcerns_text="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                          
                        </div>
                      </div>


                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
          <div class="row" *ngIf="CurrentSaveSingleEmbryoGradeInfoRequest.IsFreeze">
            <div class="col-md-12">
              <div class="card background-lightpink">
                <div class="card-body padding-all-0px">
                  <div class="row my-profile-form margin-top-10">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Location </label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" id="CurrentSaveSingleEmbryoGradeInfoRequest.Location"
                                 [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Location"
                                 name="CurrentSaveSingleEmbryoGradeInfoRequest.Location"
                                 placeholder="City" maxlength="20" minlength="1" #EmergencyAddress="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                          <small class="form-text text-danger"
                                 *ngIf="(!EmergencyAddress.valid && (EmergencyAddress.dirty || EmergencyAddress.touched) && EmergencyAddress.errors.required)">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!EmergencyAddress.valid && EmergencyAddress.errors.pattern)">(special characters are not allowed)</small>

                        </div>

                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Straw No &amp; color</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Cather Loaded By"
                           id="CurrentSaveSingleEmbryoGradeInfoRequest.StrawNo"
                         [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.StrawNo"
                         name="CurrentSaveSingleEmbryoGradeInfoRequest.StrawNo" #Doctor="ngModel"
                         maxlength="100" required>
                          <!--<small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="CurrentSaveSingleEmbryoGradeInfoRequest.IsTransfer">
            <div class="col-md-12">
              <div class="card background-lightpink">
                <div class="card-body padding-all-0px">
                  <div class="row my-profile-form margin-top-10">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                        </div>

                        <div class="col-md-4 padding-right-0px">
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                           name="CurrentSaveSingleEmbryoGradeInfoRequest.Remarks"
                         [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Remarks" required minlength="1" maxlength="100"
                         #addconcerns_text="ngModel"></textarea>
                          <small class="form-text text-danger"
                        *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
   
    </div>
    <!--<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
  </div>-->
    </div>
      </form>
  </div>
  </div>
